import   { FC } from "react";
import { Button } from "react-bootstrap";  
import { ButtonProps } from "../../../../utils/types";

const LoginButton: FC<ButtonProps> = ({ login, handleClick, loading, t }) => {
  function VerifyLogin(): boolean {
    let loginFormIsvalid =
      login.username !== undefined &&
      login.username !== null &&
      login.username.trim() !== "" &&
      login.password !== undefined &&
      login.password !== null &&
      login.password.trim() !== "";
    return loginFormIsvalid;
  }
  function VerifyLoginAndTerms(): boolean {
    let loginFormIsvalid = !loading && login.terms === true && VerifyLogin();
    return loginFormIsvalid;
  }
  return (
    <Button
    id="loginButton"
      variant={VerifyLoginAndTerms() ? "primary" : "secondary"}
      style={{
        cursor: VerifyLoginAndTerms() ? "pointer" : "",
        marginTop: "10px",
        width: "100%",
        whiteSpace: "normal",
        wordWrap: "break-word",
        minHeight: "38px",
        height: "auto",
        padding: "8px 16px",
        lineHeight: "1.3",
        fontSize: "0.875rem!important",
        textAlign: "center",
      }}
      disabled={!VerifyLoginAndTerms()}
      onClick={handleClick}
    >
      {
        handleMenssageLoginButton(VerifyLogin(), loading, login.terms, t)         
      }
    </Button>
  );
};  
export default LoginButton;

export function handleMenssageLoginButton(
  loginFormIsvalid: boolean,
  loading: boolean,
  loginterms: boolean,
  translate
)  {
  let resultContent: string = translate("login.submit.access");
  if (loading) return translate("login.submit.loading");
  if (!loginFormIsvalid) return translate("login.submit.missingUsername");
  if (!loginterms) return translate("login.submit.missingTos");
  return resultContent;
}